module.exports = __webpack_public_path__ + "static/media/mentor_business.3ab8959e.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/mentor_business.png
// module id = 401
// module chunks = 0